// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Upload_wrapper__3Mxh8","dropzoneWrapper":"Upload_dropzoneWrapper__2GTLM"};